export default "assets/images/logo-842193ee.svg";